import { createRouter, createWebHistory } from 'vue-router';
import HomePage from '../components/HomePage.vue';
import LogIn from '../components/LogIn.vue';
import UserProfile from '../components/UserProfile.vue';
import ProductList from '../components/ProductList.vue';
import ProductCategoryPage from '../components/ProductCategoryPage.vue';
import ProductDetail from '../components/ProductDetail.vue';
import ImpressumPage from '../components/ImpressumPage.vue';
import KontaktPage from '../components/KontaktPage.vue';
import AdminPanel from '../components/AdminPanel.vue';
import { verifyAdminByUsername } from '../services/dbApi';

const routes = [
    {
        path: "/",
        name: "HomePage",
        component: HomePage,
    },
    {
        path: "/LogIn",
        name: "LogIn",
        component: LogIn,
    },
    {
        path: "/UserProfile",
        name: "UserProfile",
        component: UserProfile,
    },
    {
        path: "/products",
        name: "ProductList",
        component: ProductList,
    },
    {
        path: "/products/kategorie/:slug",
        name: "ProductCategoryPage",
        component: ProductCategoryPage,
    },
    {
        path: "/products/:id",
        name: "ProductDetail",
        component: ProductDetail,
        props: true 
    },
    
    {
        path: "/kontakt",
        name: "KontaktPage",
        component: KontaktPage,
    },
    {
        path: "/impressum",
        name: "ImpressumPage",
        component: ImpressumPage,
    },
    {
        path: "/admin",
        name: "AdminPanel",
        component: AdminPanel,
        meta: { requiresAdmin: true }
    },
];
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
});

router.beforeEach(async (to, from, next) => {
    if (to.meta.requiresAdmin) {
        const username = sessionStorage.getItem('username');
        
        if (!username) {
            alert('Du musst angemeldet sein um diese Seite zu besuchen!');
            next('/LogIn');
            return;
        }

        try {
            const isAdmin = await verifyAdminByUsername(username);
            
            sessionStorage.setItem('isAdmin', isAdmin ? 'true' : 'false');
            
            if (isAdmin) {
                next();
            } else {
                alert('Du hast keine Berechtigung für diese Seite!');
                next('/');
            }
        } catch (err) {
            console.error('Fehler bei Admin-Verifizierung:', err);
            alert('Fehler bei der Admin-Verifizierung');
            next('/');
        }
    } else {
        next();
    }
});

export default router;